import type { BreakpointDefinitions } from "./breakpoints.types";
interface BreakpointMediaQueryProps {
	min?: number;
	max?: number;
	direction?: "up" | "down";
}

export const breakpointMediaQuery = ({
	min,
	max,
	direction,
}: BreakpointMediaQueryProps) => {
	const query: string[] = [];
	if (min && direction !== "down") {
		query.push(`(min-width: ${min}px)`);
	}
	if (max && direction !== "up") {
		query.push(`(max-width: ${max}px)`);
	}

	if (query.length === 0) {
		return "@media ";
	}

	return `@media ${query.join(" and ")}`;
};

export const createBreakpointMediaQueries =
	(breakpoints: BreakpointDefinitions) =>
	(
		point: keyof BreakpointDefinitions | "xldesktop",
		direction?: "up" | "down",
	) => {
		let min: number | undefined;
		let max: number | undefined;
		if (point === "tablet") {
			min = breakpoints.mobile + 1;
			max = breakpoints.tablet;
		} else if (point === "desktop") {
			min = breakpoints.tablet + 1;
			max = breakpoints.desktop;
		} else if (point === "xldesktop") {
			min = breakpoints.desktop + 1;
		} else {
			max = breakpoints.mobile;
		}

		return breakpointMediaQuery({
			min,
			max,
			direction,
		});
	};

export default breakpointMediaQuery;
